import { render, staticRenderFns } from "./MFADisable.vue?vue&type=template&id=a5ace09a"
import script from "./MFADisable.vue?vue&type=script&lang=js"
export * from "./MFADisable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports